import {
    LegacyFilmPlayerBaseInfoContent,
    LegacyVideoPlayerBaseInfoContent,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { getFilmOtt } from './get-film-ott';

export function getFilmPreviewData(
    filmOrVideo:
        | LegacyFilmPlayerBaseInfoContent
        | LegacyVideoPlayerBaseInfoContent
        | undefined
        | null
) {
    const preview = filmOrVideo && getFilmOtt(filmOrVideo)?.preview;

    if (preview?.__typename !== 'OttPreview_AbstractVideo') {
        return undefined;
    }

    return preview || undefined;
}
